import React from "react";
const Input = ({
    disabled = false,
    placeholder,
    valor,
    rows = 1,
    label,
    type = "text",
    min = null,
    onChange = () => { },
    onKeyDown,
}) => {
    return (
        <>
            <div style={{ width: "100%" }}>
                <p style={{
                    margin: "0",
                    fontSize: "12px",
                    fontFamily: "Lexend",
                    fontWeight: 400,
                    color: "#838383",
                    marginBottom: "5px",
                }}>{label}</p>
                <input
                    disabled={disabled}
                    rows={rows}
                    style={{
                        border: "8px",
                        background: disabled ? "#F6F6F6" : "#F6F6F6",
                        "-webkit-appearance": "none",
                        "-webkit-date-and-time-value": {
                            textAlign: "left",
                        },
                        "-webkit-box-shadow": "0px 4px 8px 0px rgba(0, 0, 0, 0.08)",
                        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.08)",
                        minWidth: "100%",
                        color: disabled ? "#A9A9A9" : "#838383",
                        fontSize: "12px",
                        fontFamily: "Lexend",
                        height: "50px",
                        paddingLeft: "17px",
                        paddingRight: "17px",
                        fontWeight: 400,
                        cursor: disabled ? "default" : "text",
                        outline: "none",
                    }}
                    placeholder={placeholder}
                    value={valor}
                    lang="es-MX"
                    min={min}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    type={type}
                />
            </div>
        </>
    );
};

export default Input;
